/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 15.06.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Button, ListGroupItem } from 'external/react-bootstrap';
import { translation } from 'plugin/liferay-widgets-react-web';

class MapConfigListItem extends React.Component {

    onDelete(e){
        e.stopPropagation();
        this.props.onDelete(this.props.item);
    }

    render(){

        const dataItem = this.props.item,
            item = dataItem && (dataItem.item || dataItem),
            { onClick, onDelete, ...rest } = this.props;

        return (
            <ListGroupItem
                {...rest}
                className="d-flex align-items-center justify-content-between"
                onClick={onClick.bind(this, dataItem)} 
                action
            >
                {item.title + ' - (' + item.description + ')'}
                
                {
                    onDelete &&
                    <Button
                        variant="outline-danger"
                        size="sm"
                        title="Löschen"
                        onClick={this.onDelete.bind(this)}
                    >
                        {translation.trans('delete')}
                    </Button>
                }

            </ListGroupItem>
        );
    }
}

MapConfigListItem.propTypes = {
    ...ListGroupItem.propTypes,
    item: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    onDelete: PropTypes.func
};

export default MapConfigListItem;



// WEBPACK FOOTER //
// ./js/components/MapConfigListItem.jsx